import { OptionPicker, createOptionPicker } from '@vfde-brix/ws10/option-picker';
import { HtmlId } from '../enums/elementId';
import { getTariffItem } from '../util/components/optionPickerHelper';
import { addDisplayMetacodeToTariffPicker } from '../util/displayMetacodes';
import { JarvisProduct } from '@vfde-sails/avc-core';
import { createComponentById } from '@vfde-brix/ws10/core';

export const mountOptionPicker = (wrapperId: HtmlId, onChange: (value: string) => {}) =>
    createComponentById(createOptionPicker, wrapperId, {
        onChange: ({ target }) => {
            if (target && 'value' in target) {
                onChange(target.value as string);
            }
        },
    });

export const updateTariffOptionPicker = (
    optionTab: OptionPicker | null,
    tariffs: JarvisProduct[] = [],
    enabledIds?: string[],
    selectedId?: string
) => {
    if (!optionTab) {
        return;
    }

    const items = tariffs.map(tariff => {
        const isEnabled = !enabledIds || enabledIds.includes(tariff.id);

        return getTariffItem(tariff, isEnabled, selectedId);
    });

    optionTab.update({ items });
    addDisplayMetacodeToTariffPicker();
};

export const updateGigakombiPicker = (
    optionTab: OptionPicker | null,
    gigakombi: boolean = false,
    enabled: boolean = true,
) => {

    if (!optionTab) {
        return;
    }

    const props = optionTab.getProperties();

    props.items.forEach(item => {
        item.optChecked = 'true' === item.stdValue ? gigakombi : !gigakombi;
        item.optDisabled = !enabled;
    });

    optionTab.update(props);
};
